import styled from 'styled-components'

const AppContainer = styled.div`
	position: relative;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`

export { AppContainer }
